module.exports = __webpack_public_path__ + "media/images/locations/h_3-741d6058ec07e9b0306cc6ecd2abb7a4.jpg";